import { nav, win } from 'src/global';

/**
 * 是否在iframe内
 * @returns boolean
 */
export function isInIframe(): boolean {
  return window.top !== window;
}

export function isWorkbench() {
  return !!win.jDiwork;
}

/**
 * 获取当前网络类型
 * @returns string
 */
export function getNetworkType(): 'wifi' | '5g' | '4g' | '3g' | '2g' | 'offline' | 'unknown' {
  try {
    const connection = (nav as any).connection || (nav as any).mozConnection || (nav as any).webkitConnection;
    const netType = connection?.effectiveType || connection?.type || 'unknown';
    return netType;
  } catch (err) {
    return 'unknown';
  }
}

/**
 * 低优先级异步任务 requestIdleCallback
 * @param callback 需要低优先异步执行的回调函数
 * @returns Object.clear function
 */
export function setTimeoutIdle(callback: () => void, timeout = 1000) {
  let stter = 0;
  const defaultTimeout = timeout;
  if(win.requestIdleCallback) {
    stter = win.requestIdleCallback(callback, { timeout: defaultTimeout });
    return {
      clear: () => {
        try {
          win.cancelIdleCallback(stter);
        } catch (err) {}
      }
    };
  }
  stter = win.setTimeout(callback, 0);
  return {
    clear: () => {
      try {
        win.clearTimeout(stter);
      } catch (err) {}
    }
  }
}

export function isString(s: unknown): s is string {
  return typeof s === 'string';
}

export function isFunction(f: unknown): f is Function {
  return typeof f === 'function';
}

// 是否在线状态
export const isOnline = () => nav.onLine;

export const safetyResUrl = (rurl: string) => {
  if(/base64/.test(rurl)) {
    return `${rurl.substring(0, 100)}...`;
  }
  if(rurl.length > 2000) {
    return `${rurl.substring(0, 2000)}...`;
  }
  return String(rurl).trim();
};

// 处理前端时间戳可能出现带小数点的问题
export function fixDateValue(t: number) {
  return Number(String(Math.round(t)).replace(/\..*$/, ''));
}
